import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import PropTypes from 'prop-types';
import { CompositeLayer } from '@deck.gl/core';
import VectorLayer from '../VectorLayer';
import { getFeatureKeysToOmit } from '../../../ReactLeafletMap/layers/TiledVectorLayer/Tile';
var Tile = /*#__PURE__*/function (_CompositeLayer) {
  _inherits(Tile, _CompositeLayer);
  var _super = _createSuper(Tile);
  function Tile() {
    _classCallCheck(this, Tile);
    return _super.apply(this, arguments);
  }
  _createClass(Tile, [{
    key: "renderLayers",
    value: function renderLayers() {
      var _this$props = this.props,
        tileKey = _this$props.tileKey,
        featureKeysGroupedByTileKey = _this$props.featureKeysGroupedByTileKey;
      var omittedFeatureKeys = getFeatureKeysToOmit(featureKeysGroupedByTileKey, tileKey, this.props.features, this.props.fidColumnName);
      return [new VectorLayer(this.getSubLayerProps({
        omittedFeatureKeys: omittedFeatureKeys,
        options: _objectSpread(_objectSpread({}, this.props.options), {}, {
          features: this.props.features
        }),
        id: this.props.key,
        key: this.props.key,
        layerKey: this.props.layerKey || this.props.key,
        onClick: this.props.onVectorLayerClick,
        autoHighlight: this.props.hoverable,
        styleForDeck: this.props.styleForDeck,
        pointAsMarker: this.props.pointAsMarker
      }))];
    }
  }]);
  return Tile;
}(CompositeLayer);
Tile.propTypes = {
  tileKey: PropTypes.string,
  features: PropTypes.array,
  fidColumnName: PropTypes.string,
  level: PropTypes.number,
  tile: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  featureKeysGroupedByTileKey: PropTypes.array,
  // a collection of all tiles and their features for each tile in the layer
  view: PropTypes.object,
  zoom: PropTypes.number,
  width: PropTypes.number,
  height: PropTypes.number,
  crs: PropTypes.string,
  boxRangeRange: PropTypes.array,
  omittedFeatureKeys: PropTypes.array,
  style: PropTypes.object,
  mapKey: PropTypes.string,
  layerKey: PropTypes.string,
  uniqueLayerKey: PropTypes.string,
  onClick: PropTypes.func,
  opacity: PropTypes.number,
  type: PropTypes.string,
  zIndex: PropTypes.number,
  hovered: PropTypes.object,
  hoverable: PropTypes.bool,
  hoveredStyleDefinition: PropTypes.object,
  selectable: PropTypes.bool,
  selected: PropTypes.object
};
export default Tile;